import { render, staticRenderFns } from "./JdsPanelTabBar.vue?vue&type=template&id=5e6c4150&scoped=true&"
import script from "./JdsPanelTabBar.vue?vue&type=script&lang=ts&"
export * from "./JdsPanelTabBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6c4150",
  null
  
)

export default component.exports